module.exports = __webpack_public_path__ + "img/top-title.64e49e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/top-title.png
// module id = 870
// module chunks = 1